"use strict";
/**
 * @author Zhoukai
 * @date 2021/9/8
 * @time 6:10 下午
 * @fileName ParseOrderUtils.ts
 * @Description:  订单转换
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports._convertToBitfinexCertificateOrderInfo = exports._convertToEnhancedAipOrderInfo = exports._convertToSCOrderInfo = exports._convertToMTGOrderInfo = exports._convertToMTGFuturesOrderInfo = exports._convertToGridOrderInfo = exports._convertToIGOrderInfo = exports._convertToSROrderInfo = exports._convertToReverseFSAOrderInfo = exports._convertToCMFSAOrderInfo = exports._convertToFSAOrderInfo = exports._convertGridV5ToInnerOrderInfo = exports._convertGridV4ToInnerOrderInfo = exports._convertGridV3ToInnerOrderInfo = exports._convertToInnerOrderInfo = exports._convertToExternalOrderInfo = void 0;
const trade_utils_lib_1 = require("trade_utils_lib");
const ExchangeID_1 = require("../../ExchangeAPI/ExchangeID");
const TradeTypeDef_1 = require("../../ExchangeAPIAdapter/TradeTypeDef");
const CalcProfitUtils_1 = require("../CalcProfit/CalcProfitUtils");
const BaseTradingApi_1 = require("../../TradingBot/BaseTradingApi");
const TradeUtils_1 = require("../TradeUtils");
function _convertToExternalOrderInfo(value, baseDisplay, isLeverage) {
    var _a;
    return {
        id: value.bu_order_id,
        userId: value.user_id,
        orderType: value.bu_order_type,
        base: value.base,
        quote: value.quote,
        exchange: value.exchange,
        symbol: (0, BaseTradingApi_1.toSymbol)(value.base, value.quote),
        timestamp: value.create_time,
        closeTimestamp: value.close_time ? value.close_time : 0,
        state: TradeUtils_1.TradeUtils.convertState(value.status, false),
        msg: value.bu_order_data.reason_by ? value.bu_order_data.reason_by : undefined,
        key_id: value.key_id ? value.key_id : undefined,
        isRunning: TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(value.status, false)),
        externalStatus: value.status,
        innerStatus: value.bu_order_data.status,
        transferRecord: (_a = value.transfer_record) !== null && _a !== void 0 ? _a : undefined,
        baseDisplay: baseDisplay,
        isLeverage: isLeverage,
        note: value.note && value.note.length > 0 ? value.note : undefined,
        closeNote: value.close_note ? value.close_note : undefined,
        originOrderData: value,
        copyType: value.copy_type ? value.copy_type : undefined,
        copyFrom: value.copy_from ? value.copy_from : undefined,
        botName: (value === null || value === void 0 ? void 0 : value.bot_name) ? value.bot_name : undefined,
        customize_name: (value === null || value === void 0 ? void 0 : value.customize_name) ? value.customize_name : undefined,
    };
}
exports._convertToExternalOrderInfo = _convertToExternalOrderInfo;
function _convertToInnerOrderInfo(value) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    let initPrice = value.bu_order_data.open_price ? parseFloat(value.bu_order_data.open_price) : 0;
    let conditionPrice = value.bu_order_data.condition ? Number(value.bu_order_data.condition) : undefined;
    let initBaseAmount = value.bu_order_data.base_total_investment ? parseFloat(value.bu_order_data.base_total_investment) : 0;
    let initQuoteAmount = value.bu_order_data.quote_total_investment ? parseFloat(value.bu_order_data.quote_total_investment) : 0;
    let latestBaseAmount = value.bu_order_data.base_total_amount ? parseFloat(value.bu_order_data.base_total_amount) : 0;
    let latestQuoteAmount = value.bu_order_data.quote_total_amount ? parseFloat(value.bu_order_data.quote_total_amount) : 0;
    // let initTradeBaseAmount = value.bu_order_data.init_base_amount ? parseFloat(value.bu_order_data.init_base_amount) : 0;
    let baseAmount = value.bu_order_data.base_amount ? parseFloat(value.bu_order_data.base_amount) : 0;
    let quoteAmount = value.bu_order_data.quote_amount ? parseFloat(value.bu_order_data.quote_amount) : 0;
    let openAction = value.bu_order_data.open_action;
    let openBaseAmount = value.bu_order_data.open_base_amount ? parseFloat(value.bu_order_data.open_base_amount) : 0;
    let openQuoteAmount = value.bu_order_data.open_quote_amount ? parseFloat(value.bu_order_data.open_quote_amount) : 0;
    let tempTotalCost = 0;
    switch (value.bu_order_type) {
        case TradeTypeDef_1.ExchangeOrderType.gridV3:
        case TradeTypeDef_1.ExchangeOrderType.gridPro:
        case TradeTypeDef_1.ExchangeOrderType.gridV4:
        case TradeTypeDef_1.ExchangeOrderType.gridV5:
        case TradeTypeDef_1.ExchangeOrderType.gridLeverage:
            if (value.bu_order_data.trend === TradeTypeDef_1.GRID_TREND.short) {
                tempTotalCost = (0, CalcProfitUtils_1._calcTotalCostByEarnBase)(initBaseAmount, initPrice, conditionPrice, initQuoteAmount);
            }
            else {
                tempTotalCost = (0, CalcProfitUtils_1._calcTotalCostByEarnQuote)(initBaseAmount, initPrice, conditionPrice, initQuoteAmount);
            }
            break;
        case TradeTypeDef_1.ExchangeOrderType.gridV4FuturesHedgeGrid:
        case TradeTypeDef_1.ExchangeOrderType.gridFuture:
        case TradeTypeDef_1.ExchangeOrderType.gridV4Futures:
            initBaseAmount = value.bu_order_data.base_investment ? parseFloat(value.bu_order_data.base_investment) : 0;
            initQuoteAmount = value.bu_order_data.quote_investment ? parseFloat(value.bu_order_data.quote_investment) : 0;
            tempTotalCost = initQuoteAmount;
            break;
        case TradeTypeDef_1.ExchangeOrderType.gridClassic:
            tempTotalCost = (0, CalcProfitUtils_1._calcTotalCostByEarnQuote)(initBaseAmount, initPrice, conditionPrice, initQuoteAmount);
            break;
        case TradeTypeDef_1.ExchangeOrderType.gridLoan:
            if (value.bu_order_data.earn_coin === value.base) {
                tempTotalCost = (0, CalcProfitUtils_1._calcTotalCostByEarnBase)(initBaseAmount, initPrice, conditionPrice, initQuoteAmount);
            }
            else {
                tempTotalCost = (0, CalcProfitUtils_1._calcTotalCostByEarnQuote)(initBaseAmount, initPrice, conditionPrice, initQuoteAmount);
            }
            break;
        case TradeTypeDef_1.ExchangeOrderType.gridShort:
        case TradeTypeDef_1.ExchangeOrderType.gridLeverageShort:
            tempTotalCost = (0, CalcProfitUtils_1._calcTotalCostByEarnBase)(initBaseAmount, initPrice, conditionPrice, initQuoteAmount);
            break;
        default: {
            break;
        }
    }
    let tempIsConditionAndNotTriggered = false;
    let tempConditionTriggered = false;
    let tempLiquidatedTriggered = false;
    if (value.bu_order_data.condition === undefined) {
        tempIsConditionAndNotTriggered = false;
        tempConditionTriggered = false;
    }
    else {
        tempIsConditionAndNotTriggered =
            value.bu_order_data.condition !== null &&
                Number(value.bu_order_data.condition) !== 0 &&
                value.bu_order_data.condition_direction !== null &&
                (value.bu_order_data.trigger_time === null ||
                    value.bu_order_data.trigger_time === undefined ||
                    value.bu_order_data.trigger_time === 0) &&
                TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(value.status, false));
        if (value.bu_order_data.trigger_time === undefined) {
            tempConditionTriggered = false;
        }
        else {
            tempConditionTriggered =
                value.bu_order_data.trigger_time !== null &&
                    value.bu_order_data.condition !== null &&
                    Number(value.bu_order_data.condition) !== 0 &&
                    value.bu_order_data.condition_direction !== null;
        }
    }
    if (value.bu_order_data.liquidated_triggered === undefined) {
        tempLiquidatedTriggered = false;
    }
    else {
        tempLiquidatedTriggered = value.bu_order_data.liquidated_triggered ? value.bu_order_data.liquidated_triggered : false;
    }
    ///> 计算开仓时的买入/卖出数量
    // let initOpenTradeBase = initTradeBaseAmount - initBaseAmount;
    // if (value.bu_order_data.loan_amount && value.bu_order_data.loan_coin === value.base) {
    //     initOpenTradeBase -= Number(value.bu_order_data.loan_amount ?? 0);
    // }
    return {
        high: Number(value.bu_order_data.top),
        low: Number(value.bu_order_data.bottom),
        stop: value.bu_order_data.loss_stop || value.bu_order_data.loss_stop === 0 ? Number(value.bu_order_data.loss_stop) : undefined,
        number: Number(value.bu_order_data.row),
        amount: Number(value.bu_order_data.per_volume),
        trailing: value.bu_order_data.profit_stop || value.bu_order_data.profit_stop === 0 ? Number(value.bu_order_data.profit_stop) : undefined,
        openInitPrice: value.bu_order_data.init_price ? parseFloat(value.bu_order_data.init_price) : 0,
        initQuotePrice: value.bu_order_data.init_quote_price ? parseFloat(value.bu_order_data.init_quote_price) : 0,
        gridType: value.bu_order_data.grid_type,
        openPrice: value.bu_order_data.open_price,
        earnCoin: value.bu_order_data.earn_coin,
        trend: value.bu_order_data.trend,
        openAction: openAction,
        openBaseAmount: openBaseAmount,
        openQuoteAmount: openQuoteAmount,
        initPrice: initPrice,
        initBaseAmount: initBaseAmount,
        initQuoteAmount: initQuoteAmount,
        latestBaseAmount: latestBaseAmount,
        latestQuoteAmount: latestQuoteAmount,
        baseAmount: baseAmount,
        quoteAmount: quoteAmount,
        latestPrice: 0,
        closedPrice: Number((_a = value.bu_order_data.closed_price) !== null && _a !== void 0 ? _a : 0),
        closedQuotePrice: Number((_b = value.bu_order_data.closed_quote_price) !== null && _b !== void 0 ? _b : 0),
        totalInvest: (0, CalcProfitUtils_1._calcTotalCostByEarnQuote)(initBaseAmount, initPrice, conditionPrice, initQuoteAmount),
        totalCost: tempTotalCost,
        gridProfit: Number((_c = value.bu_order_data.grid_profit) !== null && _c !== void 0 ? _c : 0),
        gridProfitOriginal: Number((_d = value.bu_order_data.grid_profit) !== null && _d !== void 0 ? _d : 0),
        profitReinvest: Number((_e = value.bu_order_data.profit_reinvest) !== null && _e !== void 0 ? _e : 0),
        adjustParamsInvestmentChanged: value.bu_order_data.adjust_params_investment_changed,
        totalProfit: 0,
        unRealizedProfit: 0,
        gridProfitPercent: 0,
        unrealizedProfitPercent: 0,
        totalProfitPercent: 0,
        pairedFeeInBase: Number((_f = value.bu_order_data.paired_fee_in_base) !== null && _f !== void 0 ? _f : 0),
        pairedFeeInQuote: Number((_g = value.bu_order_data.paired_fee_in_quote) !== null && _g !== void 0 ? _g : 0),
        filledOrdersAmount: Number((_h = value.bu_order_data.closed_exchange_order_count) !== null && _h !== void 0 ? _h : 0),
        transactionAmount: Number((_j = value.bu_order_data.placed_exchange_order_count) !== null && _j !== void 0 ? _j : 0),
        convertCoin: value.bu_order_data.convert_into_earn_coin,
        canRetry: value.bu_order_data.can_retry,
        lastRetryTime: value.bu_order_data.last_retry_time,
        isAutoStopped: value.bu_order_data.is_auto_stopped ? value.bu_order_data.is_auto_stopped : false,
        trx_24h: value.bu_order_data.trx_24h ? value.bu_order_data.trx_24h : 0,
        trx_history: value.bu_order_data.exchange_order_paired_count ? value.bu_order_data.exchange_order_paired_count : 0,
        condition: conditionPrice,
        conditionDirection: value.bu_order_data.condition_direction ? Number(value.bu_order_data.condition_direction) : undefined,
        triggerTime: (_k = value.bu_order_data.trigger_time) !== null && _k !== void 0 ? _k : 0,
        isConditionAndNotTriggered: tempIsConditionAndNotTriggered,
        conditionTriggered: tempConditionTriggered,
        ///> 杠杆和借贷
        leverage: Number((_l = value.bu_order_data.leverage) !== null && _l !== void 0 ? _l : 0),
        loanCoin: value.bu_order_data.loan_coin,
        loanAmount: Number((_m = value.bu_order_data.loan_amount) !== null && _m !== void 0 ? _m : 0),
        interestAmount: Number((_o = value.bu_order_data.interest_amount) !== null && _o !== void 0 ? _o : 0),
        liquidatedTriggered: tempLiquidatedTriggered,
        liquidatedPrice: Number((_p = value.bu_order_data.liquidate_price) !== null && _p !== void 0 ? _p : 0),
        liquidatedDirection: Number((_q = value.bu_order_data.liquidate_direction) !== null && _q !== void 0 ? _q : 0),
        blowUpPrice: Number((_r = value.bu_order_data.blow_up_price) !== null && _r !== void 0 ? _r : 0),
        baseTotalAmount: Number((_s = value.bu_order_data.base_total_amount) !== null && _s !== void 0 ? _s : 0),
        quoteTotalAmount: Number((_t = value.bu_order_data.quote_total_amount) !== null && _t !== void 0 ? _t : 0),
        baseFeeReserve: Number((_u = value.bu_order_data.base_fee_reserve) !== null && _u !== void 0 ? _u : 0),
        baseFeeRemain: Number((_v = value.bu_order_data.base_fee_remain) !== null && _v !== void 0 ? _v : 0),
        quoteFeeReserve: Number((_w = value.bu_order_data.quote_fee_reserve) !== null && _w !== void 0 ? _w : 0),
        quoteFeeRemain: Number((_x = value.bu_order_data.quote_fee_remain) !== null && _x !== void 0 ? _x : 0),
        averageCost: Number((_y = value.bu_order_data.average_cost) !== null && _y !== void 0 ? _y : 0),
        riskDegree: Number((_z = value.bu_order_data.risk_degree) !== null && _z !== void 0 ? _z : 1.1),
        safeRiskDegree: Number((_0 = value.bu_order_data.risk_rate) !== null && _0 !== void 0 ? _0 : 1.3),
        baseMargin: Number((_1 = value.bu_order_data.base_margin) !== null && _1 !== void 0 ? _1 : 0),
        quoteMargin: Number((_2 = value.bu_order_data.quote_margin) !== null && _2 !== void 0 ? _2 : 0),
        totalFeeInBase: Number((_3 = value.bu_order_data.total_fee_in_base) !== null && _3 !== void 0 ? _3 : 0),
        totalFeeInQuote: Number(value.bu_order_data.total_fee_in_quote || 0),
        feeTotalInvest: Number((_4 = value.bu_order_data.fee_total_investment) !== null && _4 !== void 0 ? _4 : 0),
        avgOpenPrice: Number((_5 = value.bu_order_data.grid_average_open_price) !== null && _5 !== void 0 ? _5 : 0),
        profitWithdrawn: Number((_6 = value.bu_order_data.profit_withdrawn) !== null && _6 !== void 0 ? _6 : 0),
        openPositionBuyLimit: value.bu_order_data.open_position_buy_limit ? Number(value.bu_order_data.open_position_buy_limit) : undefined,
        openPositionSellLimit: value.bu_order_data.open_position_sell_limit
            ? Number(value.bu_order_data.open_position_sell_limit)
            : undefined,
    };
}
exports._convertToInnerOrderInfo = _convertToInnerOrderInfo;
function _convertGridV3ToInnerOrderInfo(value) {
    var _a, _b, _c, _d;
    return Object.assign(Object.assign({}, _convertToInnerOrderInfo(value)), { baseNeed: Number((_a = value.bu_order_data.base_need) !== null && _a !== void 0 ? _a : 0), quoteNeed: Number((_b = value.bu_order_data.quote_need) !== null && _b !== void 0 ? _b : 0), isTrialFund: (_c = value.bu_order_data.is_trial_fund) !== null && _c !== void 0 ? _c : false, pausePrice: Number((_d = value.bu_order_data.pause_price) !== null && _d !== void 0 ? _d : 0), realizedProfit: new trade_utils_lib_1.SafeDecimal(value.bu_order_data.realized_profit).toNumber(), lossStopDelay: value.bu_order_data.loss_stop_delay ? Number(value.bu_order_data.loss_stop_delay) : undefined, profitStopDelay: value.bu_order_data.profit_stop_delay ? Number(value.bu_order_data.profit_stop_delay) : undefined, movingOpened: !new trade_utils_lib_1.SafeDecimal(value.bu_order_data.moving_trailing_up_param).equals(0), movingIndicatorType: value.bu_order_data.moving_indicator_type ? value.bu_order_data.moving_indicator_type : undefined, movingIndicatorInterval: value.bu_order_data.moving_indicator_interval ? value.bu_order_data.moving_indicator_interval : undefined, movingIndicatorParam: value.bu_order_data.moving_indicator_param ? value.bu_order_data.moving_indicator_param : undefined, movingTrailingUpParam: value.bu_order_data.moving_trailing_up_param ? Number(value.bu_order_data.moving_trailing_up_param) : 0 });
}
exports._convertGridV3ToInnerOrderInfo = _convertGridV3ToInnerOrderInfo;
function _convertGridV4ToInnerOrderInfo(value) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24;
    let closeSellModel = TradeTypeDef_1.BotOrderCloseModel.NOT_SELL;
    if ((_a = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _a === void 0 ? void 0 : _a.close_sell_model) {
        closeSellModel = (_b = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _b === void 0 ? void 0 : _b.close_sell_model;
    }
    else {
        if (value.bu_order_data.convert_into_earn_coin) {
            closeSellModel = TradeTypeDef_1.BotOrderCloseModel.TO_QUOTE;
        }
        else {
            closeSellModel = TradeTypeDef_1.BotOrderCloseModel.NOT_SELL;
        }
    }
    let closeSellModelSP = TradeTypeDef_1.BotOrderCloseModel.TO_QUOTE;
    if ((_c = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _c === void 0 ? void 0 : _c.close_sell_model_profit_stop) {
        closeSellModelSP = (_d = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _d === void 0 ? void 0 : _d.close_sell_model_profit_stop;
    }
    let closeSellModelSL = TradeTypeDef_1.BotOrderCloseModel.TO_QUOTE;
    if ((_e = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _e === void 0 ? void 0 : _e.close_sell_model_loss_stop) {
        closeSellModelSL = (_f = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _f === void 0 ? void 0 : _f.close_sell_model_loss_stop;
    }
    return Object.assign(Object.assign({}, _convertGridV3ToInnerOrderInfo(value)), { profitAutoReinvest: !!((_g = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _g === void 0 ? void 0 : _g.profit_auto_reinvest), open_base_amount: value.bu_order_data.open_base_amount ? Number(value.bu_order_data.open_base_amount) : 0, open_quote_amount: value.bu_order_data.open_quote_amount ? Number(value.bu_order_data.open_quote_amount) : 0, openBasePrice: value.bu_order_data.open_base_price ? Number(value.bu_order_data.open_base_price) : 0, openQuotePrice: value.bu_order_data.open_quote_price ? Number(value.bu_order_data.open_quote_price) : 0, breakEvenWithoutGridProfit: value.bu_order_data.break_even_without_grid_profit
            ? Number(value.bu_order_data.break_even_without_grid_profit)
            : 0, breakEvenWithGridProfit: value.bu_order_data.break_even_with_grid_profit
            ? Number(value.bu_order_data.break_even_with_grid_profit)
            : 0, profit_reinvest: (_h = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _h === void 0 ? void 0 : _h.profit_reinvest, next_auto_reinvest_time: (_j = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _j === void 0 ? void 0 : _j.next_auto_reinvest_time, close_sell_model: closeSellModel, close_sell_model_profit_stop: closeSellModelSP, close_sell_model_loss_stop: closeSellModelSL, base_amount_before_sell: (_l = (_k = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _k === void 0 ? void 0 : _k.base_amount_before_sell) !== null && _l !== void 0 ? _l : "", quote_amount_before_sell: (_o = (_m = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _m === void 0 ? void 0 : _m.quote_amount_before_sell) !== null && _o !== void 0 ? _o : "", base_amount_sell: (_q = (_p = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _p === void 0 ? void 0 : _p.base_amount_sell) !== null && _q !== void 0 ? _q : "", quote_amount_sell: (_s = (_r = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _r === void 0 ? void 0 : _r.quote_amount_sell) !== null && _s !== void 0 ? _s : "", base_sell_price: (_u = (_t = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _t === void 0 ? void 0 : _t.base_sell_price) !== null && _u !== void 0 ? _u : "", quote_sell_price: (_w = (_v = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _v === void 0 ? void 0 : _v.quote_sell_price) !== null && _w !== void 0 ? _w : "", unlock_usdt_amount: (_y = (_x = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _x === void 0 ? void 0 : _x.unlock_usdt_amount) !== null && _y !== void 0 ? _y : "", closed_fee: (_0 = (_z = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _z === void 0 ? void 0 : _z.closed_fee) !== null && _0 !== void 0 ? _0 : null, cate_type: (_2 = (_1 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _1 === void 0 ? void 0 : _1.cate_type) !== null && _2 !== void 0 ? _2 : null, parameter_hidden: (_4 = (_3 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _3 === void 0 ? void 0 : _3.parameter_hidden) !== null && _4 !== void 0 ? _4 : false, channel: (_6 = (_5 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _5 === void 0 ? void 0 : _5.channel) !== null && _6 !== void 0 ? _6 : null, share_ratio: (_8 = (_7 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _7 === void 0 ? void 0 : _7.share_ratio) !== null && _8 !== void 0 ? _8 : null, usdt_investment: (_10 = (_9 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _9 === void 0 ? void 0 : _9.usdt_investment) !== null && _10 !== void 0 ? _10 : null, init_usdt_investment: (_12 = (_11 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _11 === void 0 ? void 0 : _11.init_usdt_investment) !== null && _12 !== void 0 ? _12 : null, share_profit: (_14 = (_13 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _13 === void 0 ? void 0 : _13.share_profit) !== null && _14 !== void 0 ? _14 : null, invest_coin: (_16 = (_15 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _15 === void 0 ? void 0 : _15.invest_coin) !== null && _16 !== void 0 ? _16 : null, profit_withdrawn_usdt: (_18 = (_17 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _17 === void 0 ? void 0 : _17.profit_withdrawn_usdt) !== null && _18 !== void 0 ? _18 : "", profit_withdrawn_usdt_u: (_20 = (_19 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _19 === void 0 ? void 0 : _19.profit_withdrawn_usdt_u) !== null && _20 !== void 0 ? _20 : "", profit_withdrawn_usdt_s: (_22 = (_21 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _21 === void 0 ? void 0 : _21.profit_withdrawn_usdt_s) !== null && _22 !== void 0 ? _22 : "", nickname: (_24 = (_23 = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _23 === void 0 ? void 0 : _23.nickname) !== null && _24 !== void 0 ? _24 : null });
}
exports._convertGridV4ToInnerOrderInfo = _convertGridV4ToInnerOrderInfo;
function _convertGridV5ToInnerOrderInfo(value) {
    var _a, _b, _c, _d;
    return Object.assign(Object.assign({}, _convertGridV4ToInnerOrderInfo(value)), { loss_stop_type: (_b = (_a = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _a === void 0 ? void 0 : _a.loss_stop_type) !== null && _b !== void 0 ? _b : TradeTypeDef_1.GridStopType.price, profit_stop_type: (_d = (_c = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _c === void 0 ? void 0 : _c.profit_stop_type) !== null && _d !== void 0 ? _d : TradeTypeDef_1.GridStopType.price });
}
exports._convertGridV5ToInnerOrderInfo = _convertGridV5ToInnerOrderInfo;
function _convertToFSAOrderInfo(value) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15, _16, _17, _18, _19, _20, _21, _22, _23, _24, _25, _26, _27, _28, _29, _30, _31, _32, _33, _34, _35, _36, _37;
    let openInvestmentValue = 0;
    if (TradeUtils_1.TradeUtils.convertState(value.status, false) === TradeTypeDef_1.ExchangeOrderStatus.submitted && Number((_a = value.bu_order_data.leverage) !== null && _a !== void 0 ? _a : 0) != 0) {
        openInvestmentValue =
            (Number((_b = value.bu_order_data.swap_position) !== null && _b !== void 0 ? _b : 0) * Number((_c = value.bu_order_data.swap_open_price) !== null && _c !== void 0 ? _c : 0)) /
                Number((_d = value.bu_order_data.leverage) !== null && _d !== void 0 ? _d : 0);
    }
    openInvestmentValue =
        Math.abs(openInvestmentValue) +
            Number((_e = value.bu_order_data.spot_position) !== null && _e !== void 0 ? _e : 0) * Number((_f = value.bu_order_data.spot_open_price) !== null && _f !== void 0 ? _f : 0) +
            Number((_g = value.bu_order_data.spot_fee) !== null && _g !== void 0 ? _g : 0) +
            Number((_h = value.bu_order_data.swap_fee) !== null && _h !== void 0 ? _h : 0);
    let annualizedReturn_30daysValue = 0;
    if (Number((_j = value.bu_order_data.funding_fee_times) !== null && _j !== void 0 ? _j : 0) !== 0 && Number((_k = value.bu_order_data.investment) !== null && _k !== void 0 ? _k : 0) !== 0) {
        annualizedReturn_30daysValue =
            (((Number(value.bu_order_data.total_funding_fee) / Number(value.bu_order_data.funding_fee_times)) * 365 * 3) /
                Number(value.bu_order_data.investment)) *
                100;
    }
    const tempOpeningPosition = TradeUtils_1.TradeUtils.convertState(value.status, false) === TradeTypeDef_1.ExchangeOrderStatus.submitted &&
        (value.bu_order_data.status === TradeTypeDef_1.OrderInnerStatus.prepare ||
            value.bu_order_data.status === TradeTypeDef_1.OrderInnerStatus.initialize ||
            value.bu_order_data.status === TradeTypeDef_1.OrderInnerStatus.lockCurrency ||
            value.bu_order_data.status === TradeTypeDef_1.OrderInnerStatus.openPosition);
    const tempAddingPosition = TradeUtils_1.TradeUtils.convertState(value.status, false) === TradeTypeDef_1.ExchangeOrderStatus.submitted &&
        ((value.bu_order_data.status === TradeTypeDef_1.OrderInnerStatus.adjustPosition && value.bu_order_data.adjust_position_direction === "open") ||
            (value.bu_order_data.status === TradeTypeDef_1.OrderInnerStatus.adjustAssets && value.bu_order_data.adjust_assets_direction === "in"));
    const tempReducingPosition = TradeUtils_1.TradeUtils.convertState(value.status, false) === TradeTypeDef_1.ExchangeOrderStatus.submitted &&
        ((value.bu_order_data.status === TradeTypeDef_1.OrderInnerStatus.adjustPosition && value.bu_order_data.adjust_position_direction === "close") ||
            (value.bu_order_data.status === TradeTypeDef_1.OrderInnerStatus.adjustAssets && value.bu_order_data.adjust_assets_direction === "out"));
    return {
        leverage: Number((_l = value.bu_order_data.leverage) !== null && _l !== void 0 ? _l : 0),
        investment: Number((_m = value.bu_order_data.investment) !== null && _m !== void 0 ? _m : 0),
        openInvestment: openInvestmentValue,
        swapExchange: value.bu_order_data.swap_exchange,
        swapBase: value.bu_order_data.swap_base,
        swapQuote: value.bu_order_data.swap_quote,
        direction: value.bu_order_data.direction,
        priceDiffLimit: Number((_o = value.bu_order_data.price_diff_limit) !== null && _o !== void 0 ? _o : 0),
        closePriceDiffLimit: -1 * Number((_p = value.bu_order_data.close_price_diff_limit) !== null && _p !== void 0 ? _p : 0),
        priceRatio: Number((_q = value.bu_order_data.price_ratio) !== null && _q !== void 0 ? _q : 0),
        spotOpenPrice: Number((_r = value.bu_order_data.spot_open_price) !== null && _r !== void 0 ? _r : 0),
        swapOpenPrice: Number((_s = value.bu_order_data.swap_open_price) !== null && _s !== void 0 ? _s : 0),
        spotPosition: Number((_t = value.bu_order_data.spot_position) !== null && _t !== void 0 ? _t : 0),
        swapPosition: Number((_u = value.bu_order_data.swap_position) !== null && _u !== void 0 ? _u : 0),
        spotFee: Number((_v = value.bu_order_data.spot_fee) !== null && _v !== void 0 ? _v : 0),
        swapFee: Number((_w = value.bu_order_data.swap_fee) !== null && _w !== void 0 ? _w : 0),
        totalFundingFee: Number((_x = value.bu_order_data.total_funding_fee) !== null && _x !== void 0 ? _x : 0),
        fundingFeeTimes: Number((_y = value.bu_order_data.funding_fee_times) !== null && _y !== void 0 ? _y : 0),
        spotRealizedPnl: Number((_z = value.bu_order_data.spot_realized_pnl) !== null && _z !== void 0 ? _z : 0),
        swapRealizedPnl: Number((_0 = value.bu_order_data.swap_realized_pnl) !== null && _0 !== void 0 ? _0 : 0),
        liquidateRealizedPnl: Number((_1 = value.bu_order_data.liquidate_realized_pnl) !== null && _1 !== void 0 ? _1 : 0),
        insuranceFee: Number((_2 = value.bu_order_data.insurance_fee) !== null && _2 !== void 0 ? _2 : 0),
        adlRealizedPnl: Number((_3 = value.bu_order_data.adl_realized_pnl) !== null && _3 !== void 0 ? _3 : 0),
        swapInitMargin: Number((_4 = value.bu_order_data.swap_init_margin) !== null && _4 !== void 0 ? _4 : 0),
        initPrice: Number((_5 = value.bu_order_data.init_price) !== null && _5 !== void 0 ? _5 : 0),
        closedPrice: Number((_6 = value.bu_order_data.closed_price) !== null && _6 !== void 0 ? _6 : 0),
        average_1day: Number((_7 = value.bu_order_data.average_1day) !== null && _7 !== void 0 ? _7 : 0),
        average_7days: Number((_8 = value.bu_order_data.average_7days) !== null && _8 !== void 0 ? _8 : 0),
        average_30days: Number((_9 = value.bu_order_data.average_30days) !== null && _9 !== void 0 ? _9 : 0),
        annualizedReturn_1day: Number((_10 = value.bu_order_data.investment) !== null && _10 !== void 0 ? _10 : 0) === 0
            ? 0
            : ((Number((_11 = value.bu_order_data.average_1day) !== null && _11 !== void 0 ? _11 : 0) * 365 * 3) / Number(value.bu_order_data.investment)) * 100,
        annualizedReturn_7days: Number((_12 = value.bu_order_data.investment) !== null && _12 !== void 0 ? _12 : 0) === 0
            ? 0
            : ((Number((_13 = value.bu_order_data.average_7days) !== null && _13 !== void 0 ? _13 : 0) * 365 * 3) / Number(value.bu_order_data.investment)) * 100,
        annualizedReturn_30days: annualizedReturn_30daysValue,
        liquidatedPrice: Number((_14 = value.bu_order_data.liquidate_price) !== null && _14 !== void 0 ? _14 : 0),
        autoClosePrice: Number((_15 = value.bu_order_data.auto_close_price) !== null && _15 !== void 0 ? _15 : 0),
        gridProfit: Number((_16 = value.bu_order_data.total_funding_fee) !== null && _16 !== void 0 ? _16 : 0),
        totalProfit: 0,
        unRealizedProfit: 0,
        gridProfitPercent: 0,
        unrealizedProfitPercent: 0,
        totalProfitPercent: 0,
        adjustAssetsDirection: value.bu_order_data.adjust_assets_direction ? value.bu_order_data.adjust_assets_direction : undefined,
        adjustAssetsSpotAmount: Number((_17 = value.bu_order_data.adjust_assets_spot_amount) !== null && _17 !== void 0 ? _17 : 0),
        adjustAssetsSwapAmount: Number((_18 = value.bu_order_data.adjust_assets_swap_amount) !== null && _18 !== void 0 ? _18 : 0),
        adjustPositionReason: value.bu_order_data.adjust_position_reason ? value.bu_order_data.adjust_position_reason : undefined,
        adjustPositionDirection: value.bu_order_data.adjust_position_direction ? value.bu_order_data.adjust_position_direction : undefined,
        adjustPositionPriceDiffLimit: Number((_19 = value.bu_order_data.adjust_position_price_diff_limit) !== null && _19 !== void 0 ? _19 : 0),
        adjustPositionTarget: Number((_20 = value.bu_order_data.adjust_position_target) !== null && _20 !== void 0 ? _20 : 0),
        adjustPositionSpotAvgPrice: Number((_21 = value.bu_order_data.adjust_position_spot_avg_price) !== null && _21 !== void 0 ? _21 : 0),
        adjustPositionSwapAvgPrice: Number((_22 = value.bu_order_data.adjust_position_swap_avg_price) !== null && _22 !== void 0 ? _22 : 0),
        adjustPositionSpotAdjustedAmount: Number((_23 = value.bu_order_data.adjust_position_spot_adjusted_amount) !== null && _23 !== void 0 ? _23 : 0),
        adjustPositionSwapAdjustedAmount: Number((_24 = value.bu_order_data.adjust_position_swap_adjusted_amount) !== null && _24 !== void 0 ? _24 : 0),
        adjustPositionSpotFee: Number((_25 = value.bu_order_data.adjust_position_spot_fee) !== null && _25 !== void 0 ? _25 : 0),
        adjustPositionSwapFee: Number((_26 = value.bu_order_data.adjust_position_swap_fee) !== null && _26 !== void 0 ? _26 : 0),
        profitWithdrawn: Number((_27 = value.bu_order_data.withdrawn_profit) !== null && _27 !== void 0 ? _27 : 0),
        chargedMargin: Number((_28 = value.bu_order_data.charged_margin) !== null && _28 !== void 0 ? _28 : 0),
        openingPosition: tempOpeningPosition,
        addingPosition: tempAddingPosition,
        reducingPosition: tempReducingPosition,
        currentTask: (_29 = value.bu_order_data.current_task) !== null && _29 !== void 0 ? _29 : undefined,
        currentTaskStatus: (_30 = value.bu_order_data.current_task_status) !== null && _30 !== void 0 ? _30 : undefined,
        insuranceDeductTotal: Number((_31 = value.bu_order_data.insurance_deduct_total) !== null && _31 !== void 0 ? _31 : 0),
        strategyDeductTotal: Number((_32 = value.bu_order_data.strategy_deduct_total) !== null && _32 !== void 0 ? _32 : 0),
        deductedProfit: Number((_33 = value.bu_order_data.deducted_profit) !== null && _33 !== void 0 ? _33 : 0),
        spotWithdrawnRealizedProfit: Number((_34 = value.bu_order_data.spot_withdrawn_realized_profit) !== null && _34 !== void 0 ? _34 : 0),
        swapWithdrawnRealizedProfit: Number((_35 = value.bu_order_data.swap_withdrawn_realized_profit) !== null && _35 !== void 0 ? _35 : 0),
        spotWithdrawnFee: Number((_36 = value.bu_order_data.spot_withdrawn_fee) !== null && _36 !== void 0 ? _36 : 0),
        swapWithdrawnFee: Number((_37 = value.bu_order_data.swap_withdrawn_fee) !== null && _37 !== void 0 ? _37 : 0),
        accumulatedFee: 0,
    };
}
exports._convertToFSAOrderInfo = _convertToFSAOrderInfo;
function _convertToCMFSAOrderInfo(value) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;
    let openInvestmentValue = 0;
    if (TradeUtils_1.TradeUtils.convertState(value.status, false) === TradeTypeDef_1.ExchangeOrderStatus.submitted) {
        openInvestmentValue = Number((_a = value.bu_order_data.swap_position) !== null && _a !== void 0 ? _a : 0) * Number((_b = value.bu_order_data.swap_open_price) !== null && _b !== void 0 ? _b : 0);
    }
    openInvestmentValue =
        Math.abs(openInvestmentValue) +
            Number((_c = value.bu_order_data.spot_position) !== null && _c !== void 0 ? _c : 0) * Number((_d = value.bu_order_data.spot_open_price) !== null && _d !== void 0 ? _d : 0) +
            Number((_e = value.bu_order_data.spot_fee) !== null && _e !== void 0 ? _e : 0) +
            Number((_f = value.bu_order_data.swap_fee) !== null && _f !== void 0 ? _f : 0);
    return {
        investment: Number((_g = value.bu_order_data.investment) !== null && _g !== void 0 ? _g : 0),
        openInvestment: openInvestmentValue,
        swapExchange: value.bu_order_data.swap_exchange,
        swapBase: value.bu_order_data.swap_base,
        swapQuote: value.bu_order_data.swap_quote,
        priceDiffLimit: Number((_h = value.bu_order_data.price_diff_limit) !== null && _h !== void 0 ? _h : 0),
        closePriceDiffLimit: -1 * Number((_j = value.bu_order_data.close_price_diff_limit) !== null && _j !== void 0 ? _j : 0),
        spotOpenPrice: Number((_k = value.bu_order_data.spot_open_price) !== null && _k !== void 0 ? _k : 0),
        swapOpenPrice: Number((_l = value.bu_order_data.swap_open_price) !== null && _l !== void 0 ? _l : 0),
        spotPosition: Number((_m = value.bu_order_data.spot_position) !== null && _m !== void 0 ? _m : 0),
        swapPosition: Number((_o = value.bu_order_data.swap_position) !== null && _o !== void 0 ? _o : 0),
        spotFee: Number((_p = value.bu_order_data.spot_fee) !== null && _p !== void 0 ? _p : 0),
        swapFee: Number((_q = value.bu_order_data.swap_fee) !== null && _q !== void 0 ? _q : 0),
        totalFundingFee: Number((_r = value.bu_order_data.total_funding_fee) !== null && _r !== void 0 ? _r : 0),
        fundingFeeTimes: Number((_s = value.bu_order_data.funding_fee_times) !== null && _s !== void 0 ? _s : 0),
        adlRealizedPnl: Number((_t = value.bu_order_data.adl_realized_pnl) !== null && _t !== void 0 ? _t : 0),
        swapInitMargin: Number((_u = value.bu_order_data.swap_init_margin) !== null && _u !== void 0 ? _u : 0),
        initPrice: Number((_v = value.bu_order_data.init_price) !== null && _v !== void 0 ? _v : 0),
        closedPrice: Number((_w = value.bu_order_data.closed_price) !== null && _w !== void 0 ? _w : 0),
        average_1day: Number((_x = value.bu_order_data.average_1day) !== null && _x !== void 0 ? _x : 0),
        average_7days: Number((_y = value.bu_order_data.average_7days) !== null && _y !== void 0 ? _y : 0),
        average_30days: Number((_z = value.bu_order_data.average_30days) !== null && _z !== void 0 ? _z : 0),
        annualizedReturn_1day: 0,
        annualizedReturn_7days: 0,
        annualizedReturn_30days: 0,
        profit: 0,
        totalProfit: 0,
        unRealizedProfit: 0,
        profitPercent: 0,
        unrealizedProfitPercent: 0,
        totalProfitPercent: 0,
        accumulatedFee: 0,
        currentTaskProgress: Number((_0 = value.bu_order_data.current_task_progress) !== null && _0 !== void 0 ? _0 : 0),
        currentTaskProgressTotal: Number((_1 = value.bu_order_data.current_task_progress_total) !== null && _1 !== void 0 ? _1 : 0),
        autoSettlement: value.bu_order_data.auto_settlement,
        realizedFundingFee: (_2 = value.bu_order_data.realized_funding_fee) !== null && _2 !== void 0 ? _2 : "0",
        realizedFundingFeeValue: (_3 = value.bu_order_data.realized_funding_fee_value) !== null && _3 !== void 0 ? _3 : "0",
        profitWithdrawn: Number((_4 = value.bu_order_data.total_withdrawn_funding_fee) !== null && _4 !== void 0 ? _4 : 0),
        settlementCoin: value.bu_order_data.settlement_coin && value.bu_order_data.settlement_coin !== ""
            ? value.bu_order_data.settlement_coin
            : value.quote,
        initialQuote: value.quote,
    };
}
exports._convertToCMFSAOrderInfo = _convertToCMFSAOrderInfo;
function _convertToReverseFSAOrderInfo(value) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6;
    let openInvestmentValue = 0;
    if (TradeUtils_1.TradeUtils.convertState(value.status, false) === TradeTypeDef_1.ExchangeOrderStatus.submitted) {
        openInvestmentValue = Number((_a = value.bu_order_data.swap_position) !== null && _a !== void 0 ? _a : 0) * Number((_b = value.bu_order_data.swap_open_price) !== null && _b !== void 0 ? _b : 0);
    }
    openInvestmentValue =
        Math.abs(openInvestmentValue) +
            Number((_c = value.bu_order_data.spot_position) !== null && _c !== void 0 ? _c : 0) * Number((_d = value.bu_order_data.spot_open_price) !== null && _d !== void 0 ? _d : 0) +
            Number((_e = value.bu_order_data.spot_fee) !== null && _e !== void 0 ? _e : 0) +
            Number((_f = value.bu_order_data.swap_fee) !== null && _f !== void 0 ? _f : 0);
    return {
        investment: Number((_g = value.bu_order_data.investment) !== null && _g !== void 0 ? _g : 0),
        openInvestment: openInvestmentValue,
        swapExchange: value.bu_order_data.swap_exchange,
        swapBase: value.bu_order_data.swap_base,
        swapQuote: value.bu_order_data.swap_quote,
        priceDiffLimit: Number((_h = value.bu_order_data.price_diff_limit) !== null && _h !== void 0 ? _h : 0),
        closePriceDiffLimit: -1 * Number((_j = value.bu_order_data.close_price_diff_limit) !== null && _j !== void 0 ? _j : 0),
        spotOpenPrice: Number((_k = value.bu_order_data.spot_open_price) !== null && _k !== void 0 ? _k : 0),
        swapOpenPrice: Number((_l = value.bu_order_data.swap_open_price) !== null && _l !== void 0 ? _l : 0),
        spotPosition: Number((_m = value.bu_order_data.spot_position) !== null && _m !== void 0 ? _m : 0),
        swapPosition: Number((_o = value.bu_order_data.swap_position) !== null && _o !== void 0 ? _o : 0),
        spotFee: Number((_p = value.bu_order_data.spot_fee) !== null && _p !== void 0 ? _p : 0),
        swapFee: Number((_q = value.bu_order_data.swap_fee) !== null && _q !== void 0 ? _q : 0),
        totalFundingFee: Number((_r = value.bu_order_data.total_funding_fee) !== null && _r !== void 0 ? _r : 0),
        fundingFeeTimes: Number((_s = value.bu_order_data.funding_fee_times) !== null && _s !== void 0 ? _s : 0),
        adlRealizedPnl: Number((_t = value.bu_order_data.adl_realized_pnl) !== null && _t !== void 0 ? _t : 0),
        swapInitMargin: Number((_u = value.bu_order_data.swap_init_margin) !== null && _u !== void 0 ? _u : 0),
        initPrice: Number((_v = value.bu_order_data.init_price) !== null && _v !== void 0 ? _v : 0),
        closedPrice: Number((_w = value.bu_order_data.closed_price) !== null && _w !== void 0 ? _w : 0),
        average_1day: Number((_x = value.bu_order_data.average_1day) !== null && _x !== void 0 ? _x : 0),
        average_7days: Number((_y = value.bu_order_data.average_7days) !== null && _y !== void 0 ? _y : 0),
        average_30days: Number((_z = value.bu_order_data.average_30days) !== null && _z !== void 0 ? _z : 0),
        annualizedReturn_1day: 0,
        annualizedReturn_7days: 0,
        annualizedReturn_30days: 0,
        profit: 0,
        totalProfit: 0,
        unRealizedProfit: 0,
        profitPercent: 0,
        unrealizedProfitPercent: 0,
        totalProfitPercent: 0,
        accumulatedFee: 0,
        currentTaskProgress: Number((_0 = value.bu_order_data.current_task_progress) !== null && _0 !== void 0 ? _0 : 0),
        currentTaskProgressTotal: Number((_1 = value.bu_order_data.current_task_progress_total) !== null && _1 !== void 0 ? _1 : 0),
        autoSettlement: value.bu_order_data.auto_settlement,
        realizedFundingFee: (_2 = value.bu_order_data.realized_funding_fee) !== null && _2 !== void 0 ? _2 : "0",
        realizedFundingFeeValue: (_3 = value.bu_order_data.realized_funding_fee_value) !== null && _3 !== void 0 ? _3 : "0",
        profitWithdrawn: Number((_4 = value.bu_order_data.total_withdrawn_funding_fee) !== null && _4 !== void 0 ? _4 : 0),
        settlementCoin: value.bu_order_data.settlement_coin && value.bu_order_data.settlement_coin !== ""
            ? value.bu_order_data.settlement_coin
            : value.quote,
        initialQuote: value.quote,
        spotRealizedPnl: Number((_5 = value.bu_order_data.spot_realized_pnl) !== null && _5 !== void 0 ? _5 : 0),
        swapRealizedPnl: Number((_6 = value.bu_order_data.swap_realized_pnl) !== null && _6 !== void 0 ? _6 : 0),
    };
}
exports._convertToReverseFSAOrderInfo = _convertToReverseFSAOrderInfo;
function _convertToSROrderInfo(value) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const itemExchangeTradeInfo = TradeUtils_1.TradeUtils.loadTradeExchangeInfo(ExchangeID_1.ExchangeID.PIONEXV2);
    let tempIsCondition = false;
    let tempIsConditionAndNotTriggered = false;
    let tempConditionTriggered = false;
    let tempTriggerTime = 0;
    const conditionResult = value.bu_order_data.portfolio.find((item) => item.condition !== null && item.condition_direction !== null);
    if (conditionResult !== undefined) {
        tempIsCondition = true;
        const filterResult = value.bu_order_data.portfolio.find((item) => item.trigger_time !== null);
        if (filterResult !== undefined) {
            tempConditionTriggered = true;
            tempTriggerTime = filterResult.trigger_time;
        }
        else {
            tempIsConditionAndNotTriggered = TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(value.status, false));
        }
    }
    return {
        totalInvest: Number((_a = value.bu_order_data.quote_total_investment) !== null && _a !== void 0 ? _a : 0),
        initQuoteAmount: Number((_b = value.bu_order_data.init_quote_amount) !== null && _b !== void 0 ? _b : 0),
        currentQuoteAmount: Number((_c = value.bu_order_data.current_quote_amount) !== null && _c !== void 0 ? _c : 0),
        closedQuoteAmount: Number((_d = value.bu_order_data.closed_quote_amount) !== null && _d !== void 0 ? _d : 0),
        rebalanceRecordCount: Number((_e = value.bu_order_data.rebalance_record_count) !== null && _e !== void 0 ? _e : 0),
        profit: Number((_f = value.bu_order_data.profit) !== null && _f !== void 0 ? _f : 0),
        unRealizedProfit: 0,
        totalProfit: 0,
        profitPercent: 0,
        unrealizedProfitPercent: 0,
        totalProfitPercent: 0,
        convertCoin: value.bu_order_data.convert_into_earn_coin,
        subType: value.bu_order_data.bu_order_sub_type,
        nextRebalanceTime: (_g = value.bu_order_data.next_rebalance_time) !== null && _g !== void 0 ? _g : 0,
        rebalanceInterval: (_h = value.bu_order_data.rebalance_interval) !== null && _h !== void 0 ? _h : 0,
        userOrderName: value.bu_order_data.user_order_name ? value.bu_order_data.user_order_name : undefined,
        rebalanceEnabled: value.bu_order_data.rebalance_enabled,
        rebalanceTriggerType: value.bu_order_data.rebalance_trigger_type,
        rebalanceParam: value.bu_order_data.rebalance_param,
        isCondition: tempIsCondition,
        isConditionAndNotTriggered: tempIsConditionAndNotTriggered,
        conditionTriggered: tempConditionTriggered,
        triggerTime: tempTriggerTime,
        stopProfitPercent: value.bu_order_data.profit_stop_percentage ? Number(value.bu_order_data.profit_stop_percentage) : undefined,
        stopLossPercent: value.bu_order_data.loss_stop_percentage !== null ? Number(value.bu_order_data.loss_stop_percentage) : undefined,
        coins: value.bu_order_data.portfolio.map((item) => {
            var _a, _b, _c, _d, _e, _f, _g;
            return {
                orderId: item.bu_order_id,
                base: item.base,
                baseDisplay: TradeUtils_1.TradeUtils.parseDisplay(item.base, value.quote, value.exchange).baseDisplay,
                percent: item.percent,
                openPrice: Number((_a = item.open_price) !== null && _a !== void 0 ? _a : 0),
                initPrice: Number((_b = item.init_price) !== null && _b !== void 0 ? _b : 0),
                initBaseAmount: Number((_c = item.init_base_amount) !== null && _c !== void 0 ? _c : 0),
                closePrice: Number((_d = item.closed_price) !== null && _d !== void 0 ? _d : 0),
                closeBaseAmount: Number((_e = item.closed_base_amount) !== null && _e !== void 0 ? _e : 0),
                currentBaseAmount: Number((_f = item.current_base_amount) !== null && _f !== void 0 ? _f : 0),
                condition: item.condition ? Number(item.condition) : undefined,
                conditionDirection: item.condition_direction ? Number(item.condition_direction) : undefined,
                triggerTime: (_g = item.trigger_time) !== null && _g !== void 0 ? _g : 0,
                isDeleted: item.is_deleted,
                slippage: item.slippage,
                close_slippage: item.close_slippage,
            };
        }),
    };
}
exports._convertToSROrderInfo = _convertToSROrderInfo;
function _convertToIGOrderInfo(value) {
    var _a, _b, _c, _d, _e, _f, _g;
    let igProfit = Number(value.bu_order_data.profit || 0);
    let puredProfit = Number(value.bu_order_data.pured_paired_profit || 0);
    let initPrice = Number(value.bu_order_data.init_price || 0);
    let initBaseAmount = Number(value.bu_order_data.init_base_amount || 0);
    let initQuoteAmount = Number(value.bu_order_data.init_quote_amount || 0);
    let latestBaseAmount = Number(value.bu_order_data.base_amount || 0);
    let latestQuoteAmount = Number(value.bu_order_data.quote_amount || 0);
    let conditionPrice = value.bu_order_data.condition ? Number(value.bu_order_data.condition) : undefined;
    let tempIsConditionAndNotTriggered = false;
    let tempConditionTriggered = false;
    if (value.bu_order_data.condition === undefined) {
        tempIsConditionAndNotTriggered = false;
        tempConditionTriggered = false;
    }
    else {
        tempIsConditionAndNotTriggered =
            value.bu_order_data.condition !== null &&
                Number(value.bu_order_data.condition) !== 0 &&
                value.bu_order_data.condition_direction !== null &&
                (value.bu_order_data.trigger_time === null || value.bu_order_data.trigger_time === undefined) &&
                TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(value.status, false));
        if (value.bu_order_data.trigger_time === undefined) {
            tempConditionTriggered = false;
        }
        else {
            tempConditionTriggered =
                value.bu_order_data.trigger_time !== null &&
                    value.bu_order_data.condition !== null &&
                    Number(value.bu_order_data.condition) !== 0 &&
                    value.bu_order_data.condition_direction !== null;
        }
    }
    return {
        stop: value.bu_order_data.loss_stop ? Number(value.bu_order_data.loss_stop) : undefined,
        trailing: value.bu_order_data.profit_stop ? Number(value.bu_order_data.profit_stop) : undefined,
        investment: 0,
        queryOrderTimestamp: 0,
        low: Number((_a = value.bu_order_data.bottom) !== null && _a !== void 0 ? _a : 0),
        bounds: Number((_b = value.bu_order_data.bounds) !== null && _b !== void 0 ? _b : 0),
        openInitPrice: initPrice,
        rate: Number((_c = value.bu_order_data.rate) !== null && _c !== void 0 ? _c : 0),
        totalCost: value.bu_order_data.paired_cost ? Number(value.bu_order_data.paired_cost) : 0,
        totalFeeInQuote: value.bu_order_data.paired_fee_in_quote ? Number(value.bu_order_data.paired_fee_in_quote) : 0,
        totalFeeRefundInQuote: value.bu_order_data.paired_fee_refund_in_quote ? Number(value.bu_order_data.paired_fee_refund_in_quote) : 0,
        puredCost: value.bu_order_data.pured_paired_cost ? Number(value.bu_order_data.pured_paired_cost) : 0,
        puredFeeInQuote: value.bu_order_data.pured_paired_fee_in_quote ? Number(value.bu_order_data.pured_paired_fee_in_quote) : 0,
        puredFeeRefundInQuote: value.bu_order_data.pured_paired_fee_refund_in_quote
            ? Number(value.bu_order_data.pured_paired_fee_refund_in_quote)
            : 0,
        userDefineFeeRate: value.bu_order_data.user_defined_fee_rate !== null ? Number(value.bu_order_data.user_defined_fee_rate) : null,
        initPrice: initPrice,
        totalInvest: (conditionPrice ? conditionPrice : initPrice) * initBaseAmount + initQuoteAmount,
        transactionAmount: Number((_d = value.bu_order_data.closed_exchange_order_count) !== null && _d !== void 0 ? _d : 0),
        profit: igProfit,
        profitOriginal: igProfit,
        profitPercent: 0,
        puredProfit: puredProfit,
        puredProfitOrigin: puredProfit,
        puredProfitPercent: 0,
        unrealizedProfit: 0,
        unrealizedProfitPercent: 0,
        puredUnrealizedProfit: 0,
        puredUnrealizedProfitPercent: 0,
        totalProfit: 0,
        totalProfitPercent: 0,
        puredTotalProfit: 0,
        puredTotalProfitPercent: 0,
        trx_history: Number((_e = value.bu_order_data.exchange_order_pair_count) !== null && _e !== void 0 ? _e : 0),
        closedPrice: value.bu_order_data.closed_price === null || value.bu_order_data.closed_price === undefined
            ? undefined
            : Number(value.bu_order_data.closed_price),
        closedQuotePrice: value.bu_order_data.closed_quote_price === null || value.bu_order_data.closed_quote_price === undefined
            ? undefined
            : Number(value.bu_order_data.closed_quote_price),
        latestBaseAmount: latestBaseAmount,
        latestQuoteAmount: latestQuoteAmount,
        canRetry: value.bu_order_data.can_retry,
        lastRetryTime: value.bu_order_data.last_retry_time,
        investAllocate: Number((_f = value.bu_order_data.invest_allocate) !== null && _f !== void 0 ? _f : 0),
        condition: conditionPrice,
        conditionDirection: value.bu_order_data.condition_direction ? Number(value.bu_order_data.condition_direction) : undefined,
        triggerTime: (_g = value.bu_order_data.trigger_time) !== null && _g !== void 0 ? _g : 0,
        isConditionAndNotTriggered: tempIsConditionAndNotTriggered,
        conditionTriggered: tempConditionTriggered,
    };
}
exports._convertToIGOrderInfo = _convertToIGOrderInfo;
function _convertToGridOrderInfo(value) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    let gridProfit = value.bu_order_data.grid_profit ? parseFloat(value.bu_order_data.grid_profit) : 0;
    let puredGridProfit = value.bu_order_data.pured_paired_profit ? parseFloat(value.bu_order_data.pured_paired_profit) : 0;
    let initPrice = value.bu_order_data.init_price ? parseFloat(value.bu_order_data.init_price) : 0;
    let initBaseAmount = value.bu_order_data.init_base_amount ? parseFloat(value.bu_order_data.init_base_amount) : 0;
    let initQuoteAmount = value.bu_order_data.init_quote_amount ? parseFloat(value.bu_order_data.init_quote_amount) : 0;
    let latestBaseAmount = value.bu_order_data.base_amount ? parseFloat(value.bu_order_data.base_amount) : 0;
    let latestQuoteAmount = value.bu_order_data.quote_amount ? parseFloat(value.bu_order_data.quote_amount) : 0;
    return {
        queryOrderTimestamp: 0,
        high: Number((_a = value.bu_order_data.top) !== null && _a !== void 0 ? _a : 0),
        low: Number((_b = value.bu_order_data.bottom) !== null && _b !== void 0 ? _b : 0),
        amount: Number((_c = value.bu_order_data.per_volume) !== null && _c !== void 0 ? _c : 0),
        number: Number((_d = value.bu_order_data.row) !== null && _d !== void 0 ? _d : 0),
        stop: Number((_e = value.bu_order_data.loss_stop) !== null && _e !== void 0 ? _e : 0),
        trx_history: Number((_f = value.bu_order_data.exchange_order_pair_count) !== null && _f !== void 0 ? _f : 0),
        totalCost: Number((_g = value.bu_order_data.paired_cost) !== null && _g !== void 0 ? _g : 0),
        totalFeeInQuote: Number((_h = value.bu_order_data.paired_fee_in_quote) !== null && _h !== void 0 ? _h : 0),
        totalFeeRefundInQuote: Number((_j = value.bu_order_data.paired_fee_refund_in_quote) !== null && _j !== void 0 ? _j : 0),
        puredCost: Number((_k = value.bu_order_data.pured_paired_cost) !== null && _k !== void 0 ? _k : 0),
        puredFeeInQuote: Number((_l = value.bu_order_data.pured_paired_fee_in_quote) !== null && _l !== void 0 ? _l : 0),
        puredFeeRefundInQuote: Number((_m = value.bu_order_data.pured_paired_fee_refund_in_quote) !== null && _m !== void 0 ? _m : 0),
        userDefineFeeRate: value.bu_order_data.user_defined_fee_rate !== null ? Number(value.bu_order_data.user_defined_fee_rate) : null,
        initPrice: initPrice,
        totalInvest: initPrice * initBaseAmount + initQuoteAmount,
        transactionAmount: value.bu_order_data.closed_exchange_order_count,
        gridProfit: gridProfit,
        gridProfitPercent: 0,
        gridProfitOriginal: gridProfit,
        puredGridProfit: puredGridProfit,
        puredGridProfitPercent: 0,
        puredGridProfitOriginal: puredGridProfit,
        unrealizedProfit: 0,
        unrealizedProfitPercent: 0,
        puredUnrealizedProfit: 0,
        puredUnrealizedProfitPercent: 0,
        totalProfit: 0,
        totalProfitPercent: 0,
        puredTotalProfit: 0,
        puredTotalProfitPercent: 0,
        closedPrice: value.bu_order_data.closed_price === null || value.bu_order_data.closed_price === undefined
            ? undefined
            : Number(value.bu_order_data.closed_price),
        closedQuotePrice: value.bu_order_data.closed_quote_price === null || value.bu_order_data.closed_quote_price === undefined
            ? undefined
            : Number(value.bu_order_data.closed_quote_price),
        latestBaseAmount: latestBaseAmount,
        latestQuoteAmount: latestQuoteAmount,
        exchangeOrderIds: [],
        exchangeOrders: [],
        canRetry: value.bu_order_data.can_retry,
        lastRetryTime: value.bu_order_data.last_retry_time,
        isAutoStopped: value.bu_order_data.is_auto_stopped ? value.bu_order_data.is_auto_stopped : false,
    };
}
exports._convertToGridOrderInfo = _convertToGridOrderInfo;
function _convertToMTGFuturesOrderInfo(value) {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    const { bu_order_data, quote, exchange, status } = value;
    const ui_extra_data_obj = (bu_order_data === null || bu_order_data === void 0 ? void 0 : bu_order_data.ui_extra_data) ? JSON.parse(bu_order_data === null || bu_order_data === void 0 ? void 0 : bu_order_data.ui_extra_data) : null;
    let isCondition = false, conditionTriggered = false, isConditionAndNotTriggered = false, triggerTime = undefined;
    const conditionResult = (_a = bu_order_data === null || bu_order_data === void 0 ? void 0 : bu_order_data.portfolio) === null || _a === void 0 ? void 0 : _a.find((item) => !new trade_utils_lib_1.SafeDecimal(item === null || item === void 0 ? void 0 : item.condition).equals(0) && !new trade_utils_lib_1.SafeDecimal(item === null || item === void 0 ? void 0 : item.condition_direction).equals(0));
    if (conditionResult !== undefined) {
        isCondition = true;
        const filterResult = (_b = bu_order_data === null || bu_order_data === void 0 ? void 0 : bu_order_data.portfolio) === null || _b === void 0 ? void 0 : _b.find((item) => (item === null || item === void 0 ? void 0 : item.trigger_time) !== null);
        if (filterResult !== undefined) {
            conditionTriggered = true;
            triggerTime = filterResult.trigger_time;
        }
        else {
            isConditionAndNotTriggered = TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(status, false));
        }
    }
    return Object.assign(Object.assign({}, bu_order_data), { orderId: bu_order_data.bu_order_id, ui_extra_data_obj, leverage: Number((_c = bu_order_data.leverage) !== null && _c !== void 0 ? _c : 0), quote_investment: (_d = bu_order_data.quote_investment) !== null && _d !== void 0 ? _d : 0, is_multi: (_e = bu_order_data.is_multi) !== null && _e !== void 0 ? _e : false, trx_24h: Number((bu_order_data === null || bu_order_data === void 0 ? void 0 : bu_order_data.trx_24h) || 0), current_round: Number((_f = bu_order_data === null || bu_order_data === void 0 ? void 0 : bu_order_data.current_round) !== null && _f !== void 0 ? _f : 0), current_round_24: Number((_g = bu_order_data === null || bu_order_data === void 0 ? void 0 : bu_order_data.current_round_24) !== null && _g !== void 0 ? _g : 0), 
        // 计算字段
        isCondition,
        isConditionAndNotTriggered,
        conditionTriggered,
        triggerTime, portfolio: (_h = bu_order_data === null || bu_order_data === void 0 ? void 0 : bu_order_data.portfolio) === null || _h === void 0 ? void 0 : _h.map((item) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
            const temp = TradeUtils_1.TradeUtils.parseDisplay(item.base, quote, exchange);
            return Object.assign(Object.assign({}, item), { baseDisplay: temp.baseDisplay, isLeverage: temp.isLeverage, closed_price: Number((_a = item.closed_price) !== null && _a !== void 0 ? _a : 0), max_active_safety_orders: Number((_b = item.max_active_safety_orders) !== null && _b !== void 0 ? _b : 0), price_scale_param: item.price_scale_type === TradeTypeDef_1.MTGCoinScaleType.custom
                    ? JSON.parse(item.price_scale_param)
                    : Number((_c = item.price_scale_param) !== null && _c !== void 0 ? _c : 0), condition: item.condition ? Number(item.condition) : undefined, condition_direction: item.condition_direction ? Number(item.condition_direction) : undefined, stop_scaling_price: new trade_utils_lib_1.SafeDecimal(item.stop_scaling_price).equals(0) ? undefined : Number(item.stop_scaling_price), stop_scaling_price_bottom: new trade_utils_lib_1.SafeDecimal(item.stop_scaling_price_bottom).equals(0)
                    ? undefined
                    : Number(item.stop_scaling_price_bottom), take_profit_trailing_percentage: new trade_utils_lib_1.SafeDecimal(item.take_profit_trailing_percentage).equals(0)
                    ? undefined
                    : Number(item.take_profit_trailing_percentage), price_scale_trailing_percentage: new trade_utils_lib_1.SafeDecimal(item.price_scale_trailing_percentage).equals(0)
                    ? undefined
                    : Number(item.price_scale_trailing_percentage), signal_param: item.signal_param ? JSON.parse(item.signal_param) : item.signal_param, round_count: Number((_d = item.round_count) !== null && _d !== void 0 ? _d : 0), current_round: Number((_e = item.current_round) !== null && _e !== void 0 ? _e : 0), current_round_close_price: Number((_f = item.current_round_close_price) !== null && _f !== void 0 ? _f : 0), position_open_price: Number((_g = item.position_open_price) !== null && _g !== void 0 ? _g : 0), position: Number((_h = item.position) !== null && _h !== void 0 ? _h : 0), take_profit_ratio: Number((_j = item.take_profit_ratio) !== null && _j !== void 0 ? _j : 0), margin_balance: Number((_k = item.margin_balance) !== null && _k !== void 0 ? _k : 0), quote_investment: Number((_l = item.quote_investment) !== null && _l !== void 0 ? _l : 0), profit: Number((_m = item.profit) !== null && _m !== void 0 ? _m : 0) });
        }) });
}
exports._convertToMTGFuturesOrderInfo = _convertToMTGFuturesOrderInfo;
function _convertToMTGOrderInfo(value) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const itemExchangeTradeInfo = TradeUtils_1.TradeUtils.loadTradeExchangeInfo(ExchangeID_1.ExchangeID.PIONEXV2);
    let tempIsCondition = false;
    let tempIsConditionAndNotTriggered = false;
    let tempConditionTriggered = false;
    let tempTriggerTime = 0;
    /// 2021年11月05日14:23:28 服务端更换为go框架，null值会被指定为0值 ，同时历史遗留问题订单列表和订单详情接口序列化不一致，导致数据类型漂移
    const conditionResult = value.bu_order_data.portfolio.find((item) => !new trade_utils_lib_1.SafeDecimal(item.condition).equals(0) && !new trade_utils_lib_1.SafeDecimal(item.condition_direction).equals(0));
    if (conditionResult !== undefined) {
        tempIsCondition = true;
        const filterResult = value.bu_order_data.portfolio.find((item) => item.trigger_time !== null);
        if (filterResult !== undefined) {
            tempConditionTriggered = true;
            tempTriggerTime = filterResult.trigger_time;
        }
        else {
            tempIsConditionAndNotTriggered = TradeUtils_1.TradeUtils.handleState(TradeUtils_1.TradeUtils.convertState(value.status, false));
        }
    }
    let tempStopLossType;
    if (value.bu_order_data.stop_loss_percentage !== null) {
        tempStopLossType = TradeTypeDef_1.MTGStopLossType.baseTotalProfit;
    }
    else if (value.bu_order_data.unrealized_stop_loss_percentage !== null) {
        tempStopLossType = TradeTypeDef_1.MTGStopLossType.baseUnrealizedProfit;
    }
    return {
        totalInvest: Number((_a = value.bu_order_data.quote_total_investment) !== null && _a !== void 0 ? _a : 0),
        profit: Number((_b = value.bu_order_data.profit) !== null && _b !== void 0 ? _b : 0),
        totalProfit: 0,
        unRealizedProfit: 0,
        profitPercent: 0,
        unrealizedProfitPercent: 0,
        totalProfitPercent: 0,
        currentQuoteAmount: Number((_c = value.bu_order_data.current_quote_amount) !== null && _c !== void 0 ? _c : 0),
        closedQuoteAmount: Number((_d = value.bu_order_data.closed_quote_amount) !== null && _d !== void 0 ? _d : 0),
        convertCoin: value.bu_order_data.convert_into_earn_coin,
        roundCount: value.bu_order_data.round_count,
        currentRound: value.bu_order_data.current_round,
        currentRoundBase: value.bu_order_data.current_round_base,
        currentRoundSellPrice: Number((_e = value.bu_order_data.current_round_sell_price) !== null && _e !== void 0 ? _e : 0),
        roundCount24h: Number((_f = value.bu_order_data.round_count_24h) !== null && _f !== void 0 ? _f : 0),
        isCondition: tempIsCondition,
        isConditionAndNotTriggered: tempIsConditionAndNotTriggered,
        conditionTriggered: tempConditionTriggered,
        triggerTime: tempTriggerTime,
        stopProfitPercent: value.bu_order_data.stop_profit_percentage ? Number(value.bu_order_data.stop_profit_percentage) : undefined,
        stopLossPercent: value.bu_order_data.stop_loss_percentage || value.bu_order_data.stop_loss_percentage === 0
            ? Number(value.bu_order_data.stop_loss_percentage)
            : undefined,
        unrealizedStopLossPercent: value.bu_order_data.unrealized_stop_loss_percentage || value.bu_order_data.unrealized_stop_loss_percentage === 0
            ? Number(value.bu_order_data.unrealized_stop_loss_percentage)
            : undefined,
        stopLossType: tempStopLossType,
        subType: value.bu_order_data.sub_order_type,
        isMulti: (_g = value.bu_order_data.is_multi) !== null && _g !== void 0 ? _g : false,
        requiredInvestment: Number((_h = value.bu_order_data.required_investment) !== null && _h !== void 0 ? _h : 0),
        maxActiveCoins: Number((_j = value.bu_order_data.max_active_coins) !== null && _j !== void 0 ? _j : 0),
        coins: value.bu_order_data.portfolio.map((item) => {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            const temp = TradeUtils_1.TradeUtils.parseDisplay(item.base, value.quote, value.exchange);
            return {
                orderId: item.bu_order_id,
                base: item.base,
                baseDisplay: temp.baseDisplay,
                isLeverage: temp.isLeverage,
                closePrice: Number((_a = item.closed_price) !== null && _a !== void 0 ? _a : 0),
                closeBaseAmount: Number((_b = item.closed_base_amount) !== null && _b !== void 0 ? _b : 0),
                currentBaseAmount: Number((_c = item.current_base_amount) !== null && _c !== void 0 ? _c : 0),
                isDeleted: item.is_deleted,
                safetyOrders: item.safety_orders,
                maxActiveSafetyOrders: Number((_d = item.max_active_safety_orders) !== null && _d !== void 0 ? _d : 0),
                priceScaleType: item.price_scale_type,
                priceScaleParam: item.price_scale_type === TradeTypeDef_1.MTGCoinScaleType.custom
                    ? JSON.parse(item.price_scale_param)
                    : Number((_e = item.price_scale_param) !== null && _e !== void 0 ? _e : 0),
                takeProfitRatio: item.take_profit_ratio,
                volumeScale: item.volume_scale,
                condition: item.condition ? Number(item.condition) : undefined,
                conditionDirection: item.condition_direction ? Number(item.condition_direction) : undefined,
                stopScalingPrice: new trade_utils_lib_1.SafeDecimal(item.stop_scaling_price).equals(0) ? undefined : Number(item.stop_scaling_price),
                stopScalingPriceBottom: new trade_utils_lib_1.SafeDecimal(item.stop_scaling_price_bottom).equals(0)
                    ? undefined
                    : Number(item.stop_scaling_price_bottom),
                takeProfitTrailingPercent: new trade_utils_lib_1.SafeDecimal(item.take_profit_trailing_percentage).equals(0)
                    ? undefined
                    : Number(item.take_profit_trailing_percentage),
                priceScaleTrailingPercent: new trade_utils_lib_1.SafeDecimal(item.price_scale_trailing_percentage).equals(0)
                    ? undefined
                    : Number(item.price_scale_trailing_percentage),
                signal_type: item.signal_type,
                signal_param: item.signal_param ? JSON.parse(item.signal_param) : item.signal_param,
                roundCount: Number((_f = item.round_count) !== null && _f !== void 0 ? _f : 0),
                currentRound: Number((_g = item.current_round) !== null && _g !== void 0 ? _g : 0),
                currentRoundSellPrice: Number((_h = item.current_round_sell_price) !== null && _h !== void 0 ? _h : 0),
            };
        }),
    };
}
exports._convertToMTGOrderInfo = _convertToMTGOrderInfo;
function _convertToSCOrderInfo(value) {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const itemExchangeTradeInfo = TradeUtils_1.TradeUtils.loadTradeExchangeInfo(ExchangeID_1.ExchangeID.PIONEXV2);
    return {
        kolImage: value.bu_order_data.kol_image,
        kolName: value.bu_order_data.kol_name,
        signalId: value.bu_order_data.kol_signal_id,
        signalName: value.bu_order_data.signal_name,
        signalDescription: value.bu_order_data.signal_description,
        totalInvest: Number((_a = value.bu_order_data.quote_total_investment) !== null && _a !== void 0 ? _a : 0),
        quoteOriginalInvestment: Number((_b = value.bu_order_data.quote_original_investment) !== null && _b !== void 0 ? _b : 0),
        dynamicMargin: value.bu_order_data.trade_type === "futures"
            ? new trade_utils_lib_1.SafeDecimal(value.bu_order_data.quote_total_investment)
                .sub(new trade_utils_lib_1.SafeDecimal(value.bu_order_data.quote_original_investment))
                .toNumber()
            : undefined,
        profit: Number((_c = value.bu_order_data.profit) !== null && _c !== void 0 ? _c : 0),
        profitOriginal: Number((_d = value.bu_order_data.profit) !== null && _d !== void 0 ? _d : 0),
        totalProfit: 0,
        unRealizedProfit: 0,
        profitPercent: 0,
        unrealizedProfitPercent: 0,
        totalProfitPercent: 0,
        currentQuoteAmount: Number((_e = value.bu_order_data.current_quote_amount) !== null && _e !== void 0 ? _e : 0),
        closedQuoteAmount: Number((_f = value.bu_order_data.closed_quote_amount) !== null && _f !== void 0 ? _f : 0),
        closedQuotePrice: value.bu_order_data.closed_quote_price === null || value.bu_order_data.closed_quote_price === undefined
            ? undefined
            : Number(value.bu_order_data.closed_quote_price),
        expiredAt: value.bu_order_data.portfolio && value.bu_order_data.portfolio.length > 0
            ? new trade_utils_lib_1.SafeDecimal(value.bu_order_data.portfolio[0].expired_at).toNumber()
            : 0,
        market: value.bu_order_data.market,
        shareRatio: new trade_utils_lib_1.SafeDecimal(value.bu_order_data.share_ratio).toNumber(),
        sharedProfit: new trade_utils_lib_1.SafeDecimal(value.bu_order_data.shared_profit).toNumber(),
        share_profit_type: value.bu_order_data.share_profit_type,
        share_profit_value: value.bu_order_data.share_profit_value,
        closedSharedQuote: new trade_utils_lib_1.SafeDecimal(value.bu_order_data.closed_shared_quote).toNumber(),
        convertCoin: value.bu_order_data.convert_into_earn_coin,
        trade_type: value.bu_order_data.trade_type,
        cate_type: (_g = value === null || value === void 0 ? void 0 : value.bu_order_data) === null || _g === void 0 ? void 0 : _g.cate_type,
        funding_fee: value.bu_order_data.funding_fee,
        lack_of_margin: (_h = value.bu_order_data.lack_of_margin) !== null && _h !== void 0 ? _h : false,
        compound: !!value.bu_order_data.compound,
        reason_by: value.bu_order_data.reason_by,
        copy_type: value.bu_order_data.copy_type,
        copy_from: value.bu_order_data.copy_from,
        coins: value.bu_order_data.portfolio
            ? (_j = value.bu_order_data.portfolio) === null || _j === void 0 ? void 0 : _j.map((item) => {
                var _a, _b, _c, _d, _e;
                const temp = TradeUtils_1.TradeUtils.parseDisplay(item.base, value.quote, value.exchange);
                return {
                    orderId: item.bu_order_id,
                    base: item.base,
                    baseDisplay: temp.baseDisplay,
                    isLeverage: temp.isLeverage,
                    closePrice: Number((_a = item.closed_price) !== null && _a !== void 0 ? _a : 0),
                    initPrice: Number((_b = item.init_price) !== null && _b !== void 0 ? _b : 0),
                    roundCount: item.round_count,
                    currentRound: item.current_round,
                    percent: item.percent,
                    closeBaseAmount: Number((_c = item.closed_base_amount) !== null && _c !== void 0 ? _c : 0),
                    currentBaseAmount: Number((_d = item.current_base_amount) !== null && _d !== void 0 ? _d : 0),
                    signal_type: item.signal_type,
                    profit: Number((_e = item.profit) !== null && _e !== void 0 ? _e : 0),
                    signal_param: item.signal_param,
                    sharedAmount: new trade_utils_lib_1.SafeDecimal(item.shared_amount).toNumber(),
                    leverage: item.leverage,
                    funding_fee: item.funding_fee,
                    qty_long: item.qty_long,
                    qty_short: item.qty_short,
                    amount_long: item.amount_long,
                    amount_short: item.amount_short,
                    amount_settle: item.amount_settle,
                    trade_base: item.trade_base,
                    maint_price: item.maint_price,
                    profit_round_count: item.profit_round_count,
                    profit_positive: item.profit_positive,
                    profit_stop_ratio: item.profit_stop_ratio,
                    loss_stop_ratio: item.loss_stop_ratio,
                };
            })
            : [],
    };
}
exports._convertToSCOrderInfo = _convertToSCOrderInfo;
function _convertToEnhancedAipOrderInfo(value) {
    var _a;
    const itemExchangeTradeInfo = TradeUtils_1.TradeUtils.loadTradeExchangeInfo(ExchangeID_1.ExchangeID.PIONEXV2);
    return {
        _origin: value.bu_order_data,
        side: value.bu_order_data.side,
        investment: new trade_utils_lib_1.SafeDecimal(value.bu_order_data.quote_total_investment).toNumber(),
        enableStaking: value.bu_order_data.enable_staking,
        currentQuoteAmount: new trade_utils_lib_1.SafeDecimal(value.bu_order_data.current_quote_amount).toNumber(),
        initQuotePrice: new trade_utils_lib_1.SafeDecimal(value.bu_order_data.init_quote_price).toNumber(),
        closedQuoteAmount: new trade_utils_lib_1.SafeDecimal(value.bu_order_data.closed_quote_amount).toNumber(),
        closedQuotePrice: new trade_utils_lib_1.SafeDecimal(value.bu_order_data.closed_quote_price).toNumber(),
        profit: 0,
        totalProfit: 0,
        unRealizedProfit: 0,
        profitPercent: 0,
        unrealizedProfitPercent: 0,
        totalProfitPercent: 0,
        convertCoin: value.bu_order_data.convert_into_earn_coin,
        stakingApr: value.bu_order_data.staking_apr,
        trigger_time: value.bu_order_data.trigger_time ? value.bu_order_data.trigger_time : undefined,
        coins: value.bu_order_data.portfolio
            ? (_a = value.bu_order_data.portfolio) === null || _a === void 0 ? void 0 : _a.map((item) => {
                const temp = TradeUtils_1.TradeUtils.parseDisplay(item.base, value.quote, value.exchange);
                return {
                    orderId: item.bu_order_id,
                    base: item.base,
                    baseDisplay: temp.baseDisplay,
                    isLeverage: temp.isLeverage,
                    interval: item.interval,
                    perVolume: new trade_utils_lib_1.SafeDecimal(item.per_volume).toNumber(),
                    orderCount: item.order_count,
                    initPrice: new trade_utils_lib_1.SafeDecimal(item.init_price).toNumber(),
                    closePrice: new trade_utils_lib_1.SafeDecimal(item.closed_price).toNumber(),
                    currentBaseAmount: new trade_utils_lib_1.SafeDecimal(item.current_base_amount).toNumber(),
                    closedBaseAmount: new trade_utils_lib_1.SafeDecimal(item.closed_base_amount).toNumber(),
                    totalFeeInBase: new trade_utils_lib_1.SafeDecimal(item.total_fee_in_base).toNumber(),
                    totalFeeInQuote: new trade_utils_lib_1.SafeDecimal(item.total_fee_in_quote).toNumber(),
                    stakingAmount: new trade_utils_lib_1.SafeDecimal(item.staking_amount).toNumber(),
                    stakingProfit: new trade_utils_lib_1.SafeDecimal(item.staking_profit).toNumber(),
                    status: item.status,
                    rawBaseAmount: new trade_utils_lib_1.SafeDecimal(item.raw_base_amount).toNumber(),
                    averagePrice: new trade_utils_lib_1.SafeDecimal(item.average_price).toNumber(),
                    lastTradeTime: item.last_trade_time,
                    firstTradeTime: item.first_trade_time,
                    priceLimit: item.price_limit,
                };
            })
            : [],
    };
}
exports._convertToEnhancedAipOrderInfo = _convertToEnhancedAipOrderInfo;
function _convertToBitfinexCertificateOrderInfo(value) {
    return {
        side: value.bu_order_data.side,
        product_id: value.bu_order_data.product_id,
        enable_recur: value.bu_order_data.enable_recur,
        init_amount: value.bu_order_data.init_amount,
        reason_by: value.bu_order_data.reason_by,
        status: value.bu_order_data.status,
        effective_duration: value.bu_order_data.effective_duration,
        lock_days: value.bu_order_data.lock_days,
        settlement_time_of_day: value.bu_order_data.settlement_time_of_day,
        external_id: value.bu_order_data.external_id,
        issue_profit_count: value.bu_order_data.issue_profit_count,
        issue_profit_amount: value.bu_order_data.issue_profit_amount,
        round: value.bu_order_data.round,
        effective_time: value.bu_order_data.effective_time,
        maturity_time: value.bu_order_data.maturity_time,
        current_apy: value.bu_order_data.current_apy,
        next_issue_profit_timestamp: value.bu_order_data.next_issue_profit_timestamp,
        next_recur_timestamp: value.bu_order_data.next_recur_timestamp,
        default_enable_recur: value.bu_order_data.default_enable_recur,
        bu_order_seq: value.bu_order_data.bu_order_seq,
        profit_delta: value.bu_order_data.profit_delta,
    };
}
exports._convertToBitfinexCertificateOrderInfo = _convertToBitfinexCertificateOrderInfo;
